module.exports = __webpack_public_path__ + "img/en-t.1061f470.png";